import 'core-js'

import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import { connect, Provider } from 'react-redux'
import { bindActionCreators } from 'redux'

import serverData, { init as initServerData } from './utils/server-data'
import configureStore from './redux/store'
import initialState from './redux/initialState'

import Navigate from './navigate'
import actions from './redux/actions'
import './css/style.css'

import { ContextProvider as WorldReadyContextProvider } from '@paypalcorp/worldready-react'

// store
const store = configureStore(initialState)

function mapStateToProps(state) {
  return state
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  }
}

class NavigateComponent extends Component {
  render() {
    return (
      <Navigate
        {...this.props}
        ulSignin={serverData.ulSignin}
        userData={serverData.user}
        requestURL={serverData.requestURL}
        isSSOEnabled={serverData.isSSOEnabled}
        deployEnv={serverData.deployEnv}
      />
    )
  }
}
const NavigateConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
)(NavigateComponent)

initServerData()
let root = document.getElementById('root')

if (!root) {
  root = document.createElement('div')
  document.body.appendChild(root)
}

ReactDOM.render(
  <WorldReadyContextProvider locale={serverData.locality.locale}>
    <Provider store={store}>
      <Router basepath={serverData.requestURI}>
        <Route exact path="*" component={NavigateConnect} />
      </Router>
    </Provider>
  </WorldReadyContextProvider>,
  root,
)
